import React from 'react';

import IRoutes from '../interfaces/IRoutes';
import Dashboard from '../pages/dashboard/Dashboard';
import NotFound from '../pages/notFound/NotFound';
import MainContainer from '../components/template/mainContainer/MainContainer';
import Profile from '../pages/profile/Profile';
import Login from '../pages/login/Login';
import ProfileField from '../pages/certificateProfile/ProfileField';
import DynamicPage from '../pages/dynamicPage/DynamicPage';
import importCerCa from './importCerCa';

const routes: IRoutes[] = [
  {
    element: <MainContainer />,
    path: '/',
    errorElement: <NotFound />,
    children: [
      {
        element: <Dashboard />,
        index: true,
      },
      {
        element: <ProfileField />,
        path: '/user-certificate',
      },
      {
        element: <NotFound />,
        path:'/not-found'
      },
      {
        element: <Login />,
        path: '/login',
      },
      {
        element: <Profile />,
        path: '/profile',
      },
      {
        element: <DynamicPage />,
        path: '*',
      },
      ...importCerCa
    ],
  },
];

export default routes;
